/* eslint-disable @typescript-eslint/no-explicit-any */
import {shallowEqual, useSelector, useDispatch} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';
import {Box, Skeleton} from '@mui/material';
import jobDetailService from '@jobseeker/common-core/services/jobdetail.service';
import {enqueueSnackbar} from 'notistack';
import dynamic from 'next/dynamic';

const PLATFORM = process.env.NEXT_PUBLIC_APP_NAME;
const isAppIIMJobs = PLATFORM === 'iimjobs';
const isAppHirist = PLATFORM === 'hirist';

type ScreeningJobSeekerProps = {
  seekerId: number;
  associationPublished: number;
  submitCallback: () => void;
  errorCallback: (err: any) => void;
  mode?: 'prod';
  loader?: React.ReactNode;
  assessmentLoginToken?: string;
};

const ScreeningJobSeeker = dynamic(
  async () => {
    const module = isAppIIMJobs
      ? await import('@iimjobs/screening')
      : await import('@hirist/screening');
    return module.ScreeningJobSeeker as React.FC<ScreeningJobSeekerProps>;
  },
  {
    ssr: false,
  }
);

const ScreeningView = ({containerStyles, onNext, handleApplyJob}: any) => {
  const dispatch = useDispatch();
  const detail = useSelector(
    (state: AppState) => state.jobDetail,
    shallowEqual
  );
  const user = useSelector((state: AppState) => state.user, shallowEqual);
  const {token = ''} = useSelector(
    (state: AppState) => state.auth.authInfo,
    shallowEqual
  );
  const onError = (err: any) => {
    if (err.code === 'E01') {
      enqueueSnackbar(`${err.msg}, Skipping to Next Step`, {variant: 'error'});

      onNext();
    } else {
      enqueueSnackbar(err.msg, {variant: 'error'});
    }
  };
  const demo = false;
  const onSuccess = async () => {
    try {
      await jobDetailService.markAssessmentComplete(detail.id);
      // enqueueSnackbar('Your form has been submitted', {variant: 'success'});
      dispatch({
        type: 'job/jobdetail/set_jobdetail',
        payload: {...detail, assessmentCompleted: 1},
      });
      if (isAppIIMJobs) {
        onNext();
      } else {
        handleApplyJob();
      }
    } catch (error) {
      enqueueSnackbar('something went wrong', {variant: 'error'});
    }
  };

  const randomWidth = () => {
    const min = 40,
      max = 100;
    const randomNumber = Math.floor(Math.random() * (max - min + 1) + min);
    return `${randomNumber}%`;
  };

  return (
    <Box
      sx={{
        ...containerStyles,
        pt: {xxs: 1, md: 2},
        pb: 5,
        px: {xxs: 1, md: 2},
        ...(isAppHirist && {
          '*': {
            fontFamily: 'Nunito Sans !important',
          },
          button: {
            bgcolor: '#E9630C !important',
            color: 'white !important',
            border: 'none !important',
            borderRadius: '4px !important',
          },
        }),
      }}
    >
      <ScreeningJobSeeker
        seekerId={demo ? 2207827 : user.profile.id}
        associationPublished={demo ? 615335 : detail.id}
        submitCallback={onSuccess}
        errorCallback={onError}
        // mode={process.env.NODE_ENV === 'production' ? 'prod' : undefined} // TODO: Revert this before going live
        mode="prod"
        loader={
          <Box minWidth={'100%'} width={'100%'}>
            {[...Array(20)].map((_, i) => (
              <Skeleton
                key={`screening-ques-${i}`}
                variant="rounded"
                width={randomWidth()}
                height={21}
                sx={{m: 2, transition: 'all 0.3s ease'}}
              />
            ))}
          </Box>
        }
        assessmentLoginToken={token}
      />
    </Box>
  );
};
export default ScreeningView;
